import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';
import { AuthGuard, CmsConfig, FeaturesConfig, FeaturesConfigModule, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { CardModule, CmsPageGuard, KeyboardFocusModule, OutletModule, PageLayoutComponent, PromotionsModule, SpinnerModule } from '@spartacus/storefront';
import { CustomIconsModule } from '../../../../../../custom/icons/custom-icons.module';
import { CustomCardModule } from '../../../../shared/components/custom-card/custom-card.module';
import { CustomOrderOverviewModule } from '../../../../shared/components/custom-order-overview/custom-order-overview.module';
import { CustomCartCouponModule } from '../../../cart/custom-cart-coupon/custom-cart-coupon.module';
import { CustomCartSharedModule } from '../../../cart/custom-cart-shared/custom-cart-shared.module';
import { CustomDeliveryModeModule } from '../../../checkout/components/checkout-delivery-mode/custom-checkout-delivery-mode.module';
import { CustomOrderDetailActionsComponent } from './custom-order-detail-actions/custom-order-detail-actions.component';
import { CustomConsignmentTrackingComponent, CustomTrackingEventsComponent } from './custom-order-detail-items';
import { CustomOrderDetailItemsComponent } from './custom-order-detail-items/custom-order-detail-items.component';
import { OrderConsignedEntriesComponent } from './custom-order-detail-items/order-consigned-entries/order-consigned-entries.component';
import { CustomOrderDetailShippingComponent } from './custom-order-detail-shipping/custom-order-detail-shipping.component';
import { CustomOrderDetailTotalsComponent } from './custom-order-detail-totals/custom-order-detail-totals.component';
import { CustomOrderDetailsService } from './custom-order-details.service';
import { CustomOrderDetailsComponent } from './custom-order-details/custom-order-details.component';

const moduleComponents = [
  CustomOrderDetailActionsComponent,
  CustomOrderDetailItemsComponent,
  CustomOrderDetailTotalsComponent,
  CustomOrderDetailShippingComponent,
  CustomTrackingEventsComponent,
  CustomConsignmentTrackingComponent,
  OrderConsignedEntriesComponent,
  CustomOrderDetailsComponent
];

@NgModule({
  imports: [
    CardModule,
    CommonModule,
    I18nModule,
    FeaturesConfigModule,
    PromotionsModule,
    CustomOrderOverviewModule,
    UrlModule,
    SpinnerModule,
    CustomCartSharedModule,
    CustomCardModule,
    CustomIconsModule,
    OutletModule,
    AddToCartModule,
    KeyboardFocusModule,
    CustomCartCouponModule,
    CustomDeliveryModeModule,
    RouterModule.forChild([
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { pageLabel: 'order', cxRoute: 'orderGuest' },
      },
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'orderDetails' },
      },
    ]),
  ],
  providers: [
    provideConfig(<CmsConfig | FeaturesConfig>{
      cmsComponents: {
        AccountOrderDetailsActionsComponent: {
          component: CustomOrderDetailActionsComponent,
        },
        AccountOrderDetailsItemsComponent: {
          component: CustomOrderDetailItemsComponent,
        },
        AccountOrderDetailsTotalsComponent: {
          component: CustomOrderDetailTotalsComponent,
        },
        AccountOrderDetailsShippingComponent: {
          component: CustomOrderDetailShippingComponent,
        },
      },
      features: {
        consignmentTracking: '1.2',
      },
    }),
    CustomOrderDetailsService,
  ],
  declarations: [...moduleComponents],
  exports: [...moduleComponents]
})
export class CustomOrderDetailsModule {
}
